import React from 'react';
import { makeStyles, MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import { BrowserRouter, Route } from 'react-router-dom';
import Belanja from '../Belanja/Belanja';
import Home from '../Home/Home';
import Order from '../Order/Order';
import OrderView from '../OrderView/OrderView';
import OlsLogin from '../OlsLogin/OlsLogin';
import OlsRegister from '../OlsRegister/OlsRegister';
import Product from '../Product/Product';
import ShoppingCart from '../ShoppingCart/ShoppingCart';
import Account from '../Account/Account';

/*
const theme = createMuiTheme({
  palette: {
    primary: {
      dark: 'rgb(0, 72, 53)',
      main: 'rgb(0, 82, 63)',
      light: 'rgb(40, 99, 87)',
    },
    secondary: {
      main: '#E33E7F',
    },
    width: {
      maxWidth: '1024px',
    },
  },
});
*/
const theme = createMuiTheme({
  palette: {
    primary: {
      dark: '#37474f',
      main: '#455a64',
      light: '#607d8b',
    },
    secondary: {
      main: '#E33E7F',
    },
    width: {
      maxWidth: '1024px',
    },
  },
});

const useStyles = makeStyles(() => ({
  page: {
    marginTop: 63,
    padding: 0,
    maxWidth: theme.palette.width.maxWidth,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#eeeeee',
  },
  appBottomNav: {
    maxWidth: theme.palette.width.maxWidth,
    width: '100%',
    position: 'fixed',
    bottom: 0,
    left: 'auto',
    right: 'auto',
  },
  navItem: {
    color: 'white',
    backgroundColor: theme.palette.primary.main,
  },
  navItemSelected: {
    color: 'white',
    backgroundColor: theme.palette.primary.light,
    '& .MuiSvgIcon-root': {
      color: 'white',
    },
  },
  fab: {
    color: 'white',
    position: 'relative',
    left: theme.spacing(4),
    bottom: theme.spacing(4),
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
  },
}));


const Main = () => {
  const classes = useStyles();
  const { pathname } = window.location;

  const arrPath = pathname.split('/');
  const username = (arrPath && arrPath.length >= 3) ? arrPath[3] : '';
  const basePath = (username && username.length >= 1) ? `/${arrPath[1]}/${arrPath[2]}/${arrPath[3]}` : window.location.pathname;

  // const navValue = (arrPath && arrPath.length >= 4) ? arrPath[4] : 'home';
  // const navValueValid = (navValue && navValue.length >= 1) ? navValue : 'home';
  // const [value, setValue] = React.useState(navValueValid);

  return (
    <BrowserRouter basename={basePath}>
      <MuiThemeProvider theme={theme}>
        <Container className={classes.page}>
          <CssBaseline />
          <Route path="/" exact component={Home} />
          <Route path="/login" component={OlsLogin} />
          <Route path="/register" component={OlsRegister} />
          <Route path="/home" component={Home} />
          <Route path="/belanja" component={Belanja} />
          <Route path="/order" exact component={Order} />
          <Route path="/orderview/:uxid" component={OrderView} />
          <Route path="/akun" exact component={Account} />
          <Route path="/product/:uxid" component={Product} />
          <Route path="/shoppingcart" exact component={ShoppingCart} />
        </Container>
      </MuiThemeProvider>
    </BrowserRouter>
  );
};

export default Main;
